// @flow

export default function urlParam(name: string, defaultValue?: string): string {
  const params = new URLSearchParams(window.location.search)
  return params.get(name) || defaultValue || ''
}
